var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[_c('ul',{staticClass:"ul-init"},_vm._l((_vm.flowData),function(item){return _c('li',{key:item.index,class:{ active: item.index === _vm.checkedIndex },on:{"click":function($event){return _vm.itemClick(item.index)}}},[_c('span',[_vm._v(_vm._s(item.desc))]),_c('div')])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }